var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanelopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.3333V7.66667C13.75 7.47222 13.6667 7.34028 13.5 7.27083C13.3333 7.20139 13.1806 7.23611 13.0417 7.375L11 9.41667C10.8333 9.58333 10.75 9.77778 10.75 10C10.75 10.2222 10.8333 10.4167 11 10.5833L13.0417 12.625C13.1806 12.7639 13.3333 12.7986 13.5 12.7292C13.6667 12.6597 13.75 12.5278 13.75 12.3333ZM4.16667 17.5C3.70833 17.5 3.31611 17.3369 2.99 17.0108C2.66389 16.6847 2.50056 16.2922 2.5 15.8333V4.16667C2.5 3.70833 2.66333 3.31611 2.99 2.99C3.31667 2.66389 3.70889 2.50056 4.16667 2.5H15.8333C16.2917 2.5 16.6842 2.66333 17.0108 2.99C17.3375 3.31667 17.5006 3.70889 17.5 4.16667V15.8333C17.5 16.2917 17.3369 16.6842 17.0108 17.0108C16.6847 17.3375 16.2922 17.5006 15.8333 17.5H4.16667ZM8.33333 15.8333H15.8333V4.16667H8.33333V15.8333Z",
    fill: "#6C6D70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelopen);
export default __webpack_public_path__ + "static/media/Panel open.a9afbc109c95fb4dd1524815b2739bd3.svg";
export { ForwardRef as ReactComponent };